import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'frontbucket.repository.downloadRepositoryLfsModalDialog.heading',
    description:
      'Heading of the modal dialog shown before downloading a repository with lfs files.',
    defaultMessage: 'Download Git LFS repository',
  },
  actionDownloadRepository: {
    id: 'frontbucket.repository.downloadRepositoryLfsModalDialog.actionDownloadRepository',
    description: 'Button that triggers download of the repository',
    defaultMessage: 'Download',
  },
  lfsLimitationsLink: {
    id: 'frontbucket.repository.downloadRepositoryLfsModalDialog.lfsLimitationsLink',
    description:
      'Text used for a link to the documentation for Git LFS limitations',
    defaultMessage: 'workaround for including Git LFS files',
  },
  downloadWarning: {
    id: 'frontbucket.repository.downloadRepositoryLfsModalDialog.downloadWarning',
    description:
      'Text with warning that Git LFS files will not be included in the repository download',
    defaultMessage:
      'Currently, Git LFS files are not included when you download an archive of the repository.',
  },
  readMore: {
    id: 'frontbucket.repository.downloadRepositoryLfsModalDialog.readMore',
    description:
      'Documentation to read more about the Git LFS files limitations.',
    defaultMessage: 'Read about the {link} in an archive.',
  },
});
